var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"round":"","depressed":"","color":"warning"},on:{"click":_vm.doCopy}},[_vm._v("Copy!")])}
var staticRenderFns = []

export { render, staticRenderFns }